export class Task {

  taskId!: number;
  type!: number;
  name!: string;
  description!: string;
  uri!: string;
//  merchant!: Merchant;

  uploaded?: Date;
  scheduled?: Date;
  completed?: Date;
  updated?: Date;
  created?: Date;

  load(data: any): Task {

    Object.assign(this, data);
/*
    if(data.merchant) {
      this.merchant = new Merchant().load(data.merchant);
    }
*/
    if (data.uploaded) {
      this.uploaded = new Date(data.uploaded);
    }

    if (data.scheduled) {
      this.scheduled = new Date(data.scheduled);
    }

    if (data.completed) {
      this.completed = new Date(data.completed);
    }

    if (data.updated) {
      this.updated = new Date(data.updated);
    }

    if (data.created) {
      this.created = new Date(data.created);
    }

    return this;
  }
}
